export const LOCAL_KEY = {
  HIDE_INTERVIEW_BANNER: "HIDE_INTERVIEW_BANNER",
};
